import { AppConfig, User } from "../../@shared/Models/Models";

export enum GuideStepEnum {
    None = "None",
    ClickSchemaBtn = "ClickSchemaBtn",
    FillSchemaForm = "FillSchemaForm",
    SaveSchema = "SaveSchema",
    OpenCreatedSchema = "OpenCreatedSchema",
    OpenDatasetTab = "OpenDatasetTab",
    ClickDatasetAddBtn = "ClickDatasetAddBtn",
    FillDatasetModal = "FillDatasetModal",
    SaveData = "SaveData",
    OpenModelTab = "OpenModelTab",
    ClickAddModelBtn = "ClickAddModelBtn",
    FillModelModal = "FillModelModal",
    SaveModel = "SaveModel",
    OpenCreatedModel = "OpenCreatedModel",
    QueueStatus = "QueueStatus",
    TrainedModelStatus = "TrainedModelStatus",
    RetrainBtn = "RetrainBtn",
    RecalculateBtn = "RecalculateBtn",
    LogsTab = "LogsTab",
    MetricsTab = "MetricsTab",
    RunBtn = "RunBtn",
}

const initialModel = {
    isShowMainLoader: true as boolean,
    alerts: [] as NotificationModel[],
    isAuthorized: undefined as User | undefined,
    userIsLoading: true as boolean,
    appConfig: {} as AppConfig,
    seats: [] as User[],
    seatsIsLoading: false as boolean,
    guideStep: GuideStepEnum.None as GuideStepEnum,
}

export const initialState = {
    mainModel: initialModel,
}

export enum NotificationModelType {
    Error = "Error",
    Success = "Success",
    Warning = "Warning",
}

export type NotificationModel = {
    type: NotificationModelType
    message: string,
    date: Date,
    lifeTime?: number
    markAsClosed?: boolean
}

export type MainStateType = typeof initialState;